import AlentoorMap from '../vendor/AlentoorMap';

AlentoorMap.init();
